
export const UserSettingDateFormat = [
  { value: 'MM_DD_YYYY', label: 'MM/DD/YYYY' },
  { value: 'DD_MM_YYYY', label: 'DD/MM/YYYY' },
  { value: 'YYYY_MM_DD', label: 'YYYY-MM-DD' },
  { value: 'YYMMDD ', label: 'YYMMDD' },
  { value: 'MMDDYY ', label: 'MMDDYY' }
];

export const UserSettingTimeFormat = [
  { value: 'HOURS_12', label: '12hrs(AM-PM)' },
  { value: 'HOURS_24', label: '24hrs' }
];

export const UserObjectDeepEqual = <T>(obj1: T, obj2: T): boolean => {
  if (obj1 === obj2) {
    return true;
  }

  if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) {
    return false;
  }

  const keys1 = Object.keys(obj1) as (keyof T)[];
  const keys2 = Object.keys(obj2) as (keyof T)[];

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (const key of keys1) {
    if (!keys2.includes(key) || !UserObjectDeepEqual(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true;
};
